<template>
  <div class="search_list">
    <div class="search_item" v-if="nodata">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="selectItem(index)"
      >{{item}}</div>
    </div>
    <div class="nodata" v-if="!nodata">
      <div class="noData" v-if="!nodata">
        <img src="../../assets/49@2x.png" alt>
        <p class="no_content">当前没有内容</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-list-2",
  props:['index'],
  data() {
    return {
      dataList: [
        "V2-登上舞台篇1",
        "V8-终端完美销售1"
      ],
      nodata: true,
      item_index: 0
    };
  },
  created(){
    console.log('currentViewIndex2',this.index)
      this.$root.center.$on('change_min_tab',data=>{
        // console.log(data)
      if(data==0){
        this.dataList = ["V2-登上舞台篇1","V8-终端完美销售1"]
        this.storeData.itemIndex = data;
        // console.log(this.storeData.itemIndex)
        // this.nodata = false;
      } else {
        // this.nodata = true
        this.dataList = [
          "V2-登上舞台篇（理论及参考答案）",
          "V2-登上舞台篇（实践题）",
          "V8-终端完美销售（理论题）",
          "V8-终端完美销售（实践题）"
        ]
        this.storeData.itemIndex = data;
        // console.log(this.storeData.itemIndex)
      }
    })
  },
  methods: {
    selectItem(index) {
      console.log('点击了第',index,'个');
      if(this.storeData.itemIndex == 0){
        this.$router.push({
          path: "/courseInfo",
          query: { id: index }
        });
      } else if(this.storeData.itemIndex == 1){
        this.$router.push({
          path: "/perview",
          query: { id: index }
        });
      }
    }
  }
};
</script>

<style scoped>
.search_list {
  width: 100%;
  height: 100%;
  background-color: rgb(240, 241, 242);
}
.search_item {
  background: #ffffff;
  box-shadow: 0 5px 20px 5px rgba(227, 232, 235, 0.75);
  border-radius: 8px;
  width: 100%;
  margin: auto;
  margin-top: 14px;
}
.search_item:last-child {
  margin-bottom: 15px;
}
.item {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #414352;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e1e6ea;
}
.item::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 15px;
  background-color: #5576ab;
}
.search-content {
  width: 100%;
  padding: 10px 15px 15px 15px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #a0a0a0;
  letter-spacing: 0;
  line-height: 23px;
  text-align: left;
  border-bottom: 1px solid #e1e6ea;
}
.search_foot {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  line-height: 50px;
  width: 100%;
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
  align-items: center;
}
.num {
  color: #333333;
}
.search_foot_right {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffc30b;
  text-align: right;
}
.integral_icon {
  width: 30px;
  height: 30px;
  vertical-align: middle;
}
.noData {
  width: 100%;
  height: 100%;
  padding-top: 20%;
}
.noData > img {
  display: block;
  margin: auto;
  width: 200px;
}
.noData .no_content {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #a0a0a0;
  letter-spacing: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/search_item/search_item2.vue